import mutations from './mutations'
import articleComposition from '@/api/articleComposition'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: ({ commit, rootState }, articleId) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        articleComposition.get({ businessUnitId, articleId })
          .then(response => {
            const items = response.data.items
            commit('setElements', { type: 'items', elements: { ...items } })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    saveItems: ({ commit, rootState }, { articleId, items }) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        articleComposition.save({ businessUnitId, articleId, items })
          .then(response => {
            const items = response.data.items
            commit('setElements', { type: 'items', elements: { ...items } })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadArticleCompositionMembership ({ commit, rootState }, articleId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        articleComposition.loadArticleCompositionMembership({ businessUnitId, articleId })
          .then(response => {
            const items = response.data.items
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadArticleCompositionHistory ({ commit, rootState }, articleId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        articleComposition.getHistory({ businessUnitId, articleId })
          .then(response => {
            const items = response.data.items
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
